import {
  useEffect,
  useState,
} from "react";

export interface MetricsResponse {
  size?: number;
  delay?: number;
  queue?: number;
  progress?: number;
  finished?: number;
}

import {
  itens_late,
  itens_queue,
  itens_progress,
  itens_finished,
} from "../contexts/Filter.provider";

export function useSidebarMetrics(events?: Sentinel.Timeline.StatusTimelineObjectResponse[]): MetricsResponse {
  const [metrics, setMetrics] = useState<MetricsResponse>();

  useEffect(() => {
    const size = events?.length;
    const delay = events?.filter(event => itens_late.includes(event.status))?.length;
    const queue = events?.filter(event => itens_queue.includes(event.status))?.length;
    const progress = events?.filter(event => itens_progress.includes(event.status))?.length;
    const finished = events?.filter(event => itens_finished.includes(event.status))?.length;

    setMetrics({
      size: size || 0,
      delay: delay || 0,
      queue: queue || 0,
      progress: progress || 0,
      finished: finished || 0,
    });
  }, [events]);

  return metrics;
}